type AddressComponents = {
  city: string | null;
  state: string | null;
  zip: string | null;
  country: string | null;
  streetAddress: string | null;
  addressLocality: string | null;
};

export function fetchAddressComponents(
  place: google.maps.places.PlaceResult
): AddressComponents {
  if (!place.address_components) {
    return {
      city: null,
      state: null,
      zip: null,
      country: null,
      streetAddress: null,
      addressLocality: null,
    };
  }

  const acMap: Record<string, google.maps.GeocoderAddressComponent> =
    place.address_components?.reduce((map, comp) => {
      comp.types.forEach((type: string) => {
        map[type] = comp;
      });
      return map;
    }, {} as Record<string, google.maps.GeocoderAddressComponent>);

  const city =
    acMap.locality?.long_name ||
    acMap.sublocality?.long_name ||
    acMap.postal_town?.long_name ||
    acMap.administrative_area_level_1?.long_name ||
    null;
  const state = acMap.administrative_area_level_1?.short_name || null;
  const zip = acMap.postal_code?.short_name || null;
  const country = acMap.country?.long_name || null;
  const streetAddress =
    `${acMap.street_number?.long_name} ${
      acMap.route?.long_name ? acMap.route?.long_name : ''
    }` || null;

  const addressLocality = `${acMap.administrative_area_level_2?.long_name} ${
    acMap.postal_town?.long_name ? acMap.postal_town?.long_name : ''
  }`;

  return {
    city,
    state,
    zip,
    country,
    streetAddress: streetAddress?.trim() || null,
    addressLocality: addressLocality?.trim() || null,
  };
}
